/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.channel.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.channel = {};
proto.witbooking.backoffice.channel.v1 = require('./channelmanager_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.channel.v1.ChannelManagerAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.channel.v1.ChannelManagerAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest,
 *   !proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse>}
 */
const methodDescriptor_ChannelManagerAPI_GetChannelManagers = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.channel.v1.ChannelManagerAPI/GetChannelManagers',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest,
  proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse,
  /**
   * @param {!proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest,
 *   !proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse>}
 */
const methodInfo_ChannelManagerAPI_GetChannelManagers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse,
  /**
   * @param {!proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.channel.v1.ChannelManagerAPIClient.prototype.getChannelManagers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.channel.v1.ChannelManagerAPI/GetChannelManagers',
      request,
      metadata || {},
      methodDescriptor_ChannelManagerAPI_GetChannelManagers,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.channel.v1.ChannelManagerAPIPromiseClient.prototype.getChannelManagers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.channel.v1.ChannelManagerAPI/GetChannelManagers',
      request,
      metadata || {},
      methodDescriptor_ChannelManagerAPI_GetChannelManagers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest,
 *   !proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse>}
 */
const methodDescriptor_ChannelManagerAPI_GetPropertyChannelManagers = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.channel.v1.ChannelManagerAPI/GetPropertyChannelManagers',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest,
  proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse,
  /**
   * @param {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest,
 *   !proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse>}
 */
const methodInfo_ChannelManagerAPI_GetPropertyChannelManagers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse,
  /**
   * @param {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.channel.v1.ChannelManagerAPIClient.prototype.getPropertyChannelManagers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.channel.v1.ChannelManagerAPI/GetPropertyChannelManagers',
      request,
      metadata || {},
      methodDescriptor_ChannelManagerAPI_GetPropertyChannelManagers,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.channel.v1.ChannelManagerAPIPromiseClient.prototype.getPropertyChannelManagers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.channel.v1.ChannelManagerAPI/GetPropertyChannelManagers',
      request,
      metadata || {},
      methodDescriptor_ChannelManagerAPI_GetPropertyChannelManagers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest,
 *   !proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse>}
 */
const methodDescriptor_ChannelManagerAPI_UpdatePropertyChannelManagers = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.channel.v1.ChannelManagerAPI/UpdatePropertyChannelManagers',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest,
  proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse,
  /**
   * @param {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest,
 *   !proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse>}
 */
const methodInfo_ChannelManagerAPI_UpdatePropertyChannelManagers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse,
  /**
   * @param {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.channel.v1.ChannelManagerAPIClient.prototype.updatePropertyChannelManagers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.channel.v1.ChannelManagerAPI/UpdatePropertyChannelManagers',
      request,
      metadata || {},
      methodDescriptor_ChannelManagerAPI_UpdatePropertyChannelManagers,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.channel.v1.ChannelManagerAPIPromiseClient.prototype.updatePropertyChannelManagers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.channel.v1.ChannelManagerAPI/UpdatePropertyChannelManagers',
      request,
      metadata || {},
      methodDescriptor_ChannelManagerAPI_UpdatePropertyChannelManagers);
};


module.exports = proto.witbooking.backoffice.channel.v1;

